export const iconFontAwesomeMathematicsWaveSquare = (
	<i className="fa-solid fa-wave-square"></i>
);
